import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { ConfirmationModalType } from "../Types";

export function ConfirmationModal({ data }: ConfirmationModalType) {
    const { t } = useTranslation();

    return (
        <StyledModal toggle={true} isOpen={data.isConfirmationModal!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() =>
                    data.setIsConfirmationModal(!data.isConfirmationModal)
                }
            >
                <span>{t("Alert")}</span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-0">
                    {t(
                        "Attention! the third party is already archived at the franchise level"
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        data.setIsConfirmationModal(!data.isConfirmationModal);
                    }}
                >
                    {t("OK")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
